import individualWorkSupportUtil from '../../../../../share/util/individualWorkSupportUtil';
import session from '../../../../../share/session';
import apiService from '../../../../../../../share/src/util/api/service';
import handler from '../../../../../share/util/apiResultValidator';
import { REQUEST_STATUS_COMPLETED } from '../../../../../../../share/src/util/api/polling';
import { PHASE } from './constants';
import { createColumns, createDisplayData } from './table';

/** 
 * プロジェクトデータ保存処理 
 * @param {object} self this インスタンス
 */
export async function save(self) {
  try {
    self.isLoading = true;
    // バックエンドAPI POST,GET
    const token = session.getToken();
    const response = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        type: 'save',
        is_special: true,
        project_id: self.vehicleInfo.vehicle.project.id,
        fd_data_list: self.preFdData,
        detail_fd_list: self.preDetailFdData,
        control_history_type: self.controlHistoryType,
      },
      // エラー発生のコールバック
      (errorType) => { errorType; self.showUnexpectedError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      (result) => { self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      (result) => { self.validateErrorResult(result); },
    );

    if (response) {
      switch (response.data.status) {
        case REQUEST_STATUS_COMPLETED:
          // プロジェクトデータ更新
          await update(self, response.data.user_data.measured_id);
          self.dataNameSuffix = self.dataNameSuffix + 1;
          self.dataName = self.$refs.projectData.inputDataName;
          self.preDataName = 'Data' + String(self.dataNameSuffix);
          self.memo = self.$refs.projectData.inputMemo;
          self.preMemo = '';
          break;
        default:
          break;
      }
    }
  } finally {
    self.isLoading = false;
    // 画面再描画の為に再度以下関数を呼び出す
    createColumns(self);
    createDisplayData(self);
    self.phase = PHASE.LIST_VIEW;
  }
}

/**
 * プロジェクトデータ更新処理
 * @param {object} self this インスタンス
 * @param {String} measuredId 計測データID
 * @returns {Boolean} フラグ
 */
async function update(self, measuredId) {
  const endPoint = '/projects/' + self.vehicleInfo.vehicle.project.id + '/' + measuredId;
  const reqBody = {
    name: self.vehicleInfo.vehicle.project.id,
    comment: self.$refs.projectData.inputDiagnoseComment,
    measured: {
      name: self.$refs.projectData.inputDataName,
      memo: self.$refs.projectData.inputMemo
    }
  };
  const res = await apiService.postCall(apiService.WSP, endPoint, reqBody, self.operationScreen);
  let ret = false;
  // APIレスポンスの検証
  handler.validate(handler.validateTypes.all, res, self, null, () => {
    ret = true;
  }, (result) => {
    // レスポンス不正時のコールバック
    if (result.behaviorType === handler.behaviorTypes.logout) {
      self.logout(self);
    } else if (result.behaviorType === handler.behaviorTypes.resetSession) {
      self.resetSession(self);
    }
  });
  return ret;
}